<template>
  <el-dialog
    title="Disponibilizar Imóvel para Venda"
    :visible.sync="visibility"
    :before-close="fechar"
    :close-on-click-modal="false"
    append-to-body
    v-loading="isLoading"
    @open="reset"
    width="35%"
  >
    <el-form :model="disponibilizarVenda" :rules="validacao" ref="formDisponibilizarVenda" size="small" label-position="top" style="margin-bottom: 20px;">
      <el-col :span="12">
        <el-form-item label="Valor de Venda(R$)" prop="valorVenda">
          <div class="el-input el-input--small">
            <money 
              v-model="disponibilizarVenda.valorVenda" 
              v-bind="money" 
              class="el-input__inner"
            />
          </div>
        </el-form-item>
      </el-col>
      
      <el-col :span="12">
        <el-form-item label="Comissão de Venda(%)" prop="comissaoVenda">
          <div class="el-input el-input--small">
            <money
              v-model="disponibilizarVenda.comissaoVenda"
              v-bind="percent"
              class="el-input__inner"
            />
          </div>
        </el-form-item>
      </el-col>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="disponibilizarVendaHandler" type="primary" round size="small" class="btn-box-shadow">Confirmar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { Money } from "v-money";

export default {
  components:{
    Money
  },
  props: {
    visibility: Boolean
  },
  data() {
    return {
      loadingUsuarios: false,

      disponibilizarVenda: {
        imovel: { id: 0 },
        valorVenda: 0,
        comissaoVenda: 0
      },
      
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      },

      percent: {
        decimal: ",",
        thousands: ".",
        suffix: " %",
        precision: 2,
        masked: false,
        min: 0.0,
        max: 100
      },

      validacao: {
        valorVenda: [{ type: "number", min: 0.01 , message: "Min:0.01"}],
        comissaoVenda: [{ type: "number", min: 0.01, max: 100 , message: "Min:0.01 / Max:100"}]
      }
    };
  },
  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),
    
    ...mapState("alugueisImoveisStore", {
      imovel(state) {
        return state.imovelSelecionado;
      }
    })
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("alugueisImoveisStore", ["disponibilizarVendaImovel"]),

    disponibilizarVendaHandler() {
      this.$refs["formDisponibilizarVenda"].validate(valid => {
        if(valid) {
          this.disponibilizarParaVenda();
        } else {
          this.exibirAlert("Atenção", "Preencha todos os campos obrigatórios");
        }
      });
    },
    disponibilizarParaVenda() {
      this.showLoading();

      this.disponibilizarVendaImovel( { ...this.disponibilizarVenda, imovel: { id: this.imovel.id }} )
      .then((resultado) => {
        this.hideLoading();
        switch(resultado.status) {
          case "SUCESSO":
            this.$message.success(resultado.mensagem);
            this.fechar();
            break;
          case "FALHA":
          case "ERRO":
            this.$message.warning(resultado.mensagem);
            this.fechar();
            break;
        }
      }).catch(() => {
        this.hideLoading();
        this.$message.error("Não foi possível comunicar-se com o servidor");
      });
    },
    reset() {
      this.disponibilizarVenda = {
        imovel: { id: 0 },
        valorVenda: 0,
        comissaoVenda: 0
      }
    },
    exibirAlert(titulo, mensagem) {
      this.$alert(mensagem, titulo, { confirmButtonText: "OK" });
    },
    fechar() {
      this.$refs["formDisponibilizarVenda"].resetFields();
      this.$emit("close");
    }
  }
};
</script>

